export default "### Token expired/invalid\n\nThe token provided is invalid or has expired.  Please <a href=\"/password-reset\">request a new token</a>."